import { render } from "./FieldTypeEdit.vue?vue&type=template&id=0e52c65f&scoped=true"
import script from "./FieldTypeEdit.vue?vue&type=script&lang=js"
export * from "./FieldTypeEdit.vue?vue&type=script&lang=js"

import "./FieldTypeEdit.vue?vue&type=style&index=0&id=0e52c65f&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e52c65f"]])

export default __exports__